module.exports = __webpack_public_path__ + "img/banner_sx02.697c8c80.png";